{
  "slug": "iq-test-reliability",
  "title": "IQ Test Reliability Explained",
  "description": "Learn what reliability means for IQ tests, including consistency, measurement error, and why reliability alone is not enough.",
  "summary": "Reliability describes the consistency or precision of scores under defined conditions. A score can be reliable without being valid for every interpretation or use.",
  "category": "Science of testing",
  "sections": [
    {
      "heading": "What reliability asks",
      "paragraphs": [
        "Reliability evidence examines whether scores are sufficiently consistent across relevant items, forms, raters, or occasions. The appropriate evidence depends on how the test is designed and used.",
        "High reliability reduces random error but does not prove that the test measures the intended construct or supports a particular decision."
      ]
    },
    {
      "heading": "Sources of inconsistency",
      "paragraphs": [
        "Fatigue, distraction, unclear instructions, device problems, item sampling, scoring, and normal day-to-day variation can affect results. Practice can also change retest performance.",
        "Standardized administration and quality control reduce avoidable variation, while confidence intervals communicate remaining uncertainty."
      ]
    },
    {
      "heading": "What to look for",
      "paragraphs": [
        "Responsible test documentation identifies the population, sample, reliability method, coefficients, standard errors, and conditions. A single unexplained “accuracy” percentage is not equivalent.",
        "Evidence should match the score being interpreted. Reliability for a total score does not automatically establish equal precision for every subscore."
      ]
    }
  ],
  "faqs": [
    {
      "question": "Does a reliable IQ test always give the same score?",
      "answer": "No. Reliability allows normal variation and is summarized statistically rather than requiring identical results."
    },
    {
      "question": "Is reliability the same as accuracy?",
      "answer": "No. Reliability concerns consistency; validity concerns whether evidence supports the intended interpretation and use."
    }
  ],
  "related": ["iq-test-validity", "iq-score-confidence-intervals", "practice-effects-on-iq-tests"],
  "sources": [
    {
      "label": "Standards for Educational and Psychological Testing",
      "url": "https://www.testingstandards.net/"
    },
    {
      "label": "International Test Commission — guidelines on test use",
      "url": "https://www.intestcom.org/page/15"
    }
  ]
}
